var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lyt-tile-grid",attrs:{"data-load":"layouts/tile-grid"}},[_c('div',{staticClass:"lyt-tile-grid__grid"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }